// src/services/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAMA6UWeL-m7EHsCQm2756edLcT66in53c",
  authDomain: "urtalequote.firebaseapp.com",
  projectId: "urtalequote",
  storageBucket: "urtalequote.firebasestorage.app",
  messagingSenderId: "635278994992",
  appId: "1:635278994992:web:7ef1a146b8c42e882587f5",
  measurementId: "G-FC55JNS10B",
};

let app, auth, db;
try {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
} catch (e) {
  console.error("Firebase init error", e);
}

export { auth, db, app };
